<template>
    <div ref="target">
        <transition :name="animationType">
            <div v-appear="animate" class="animated-component">
                <slot />
            </div>
        </transition>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'

export default defineComponent({
    name: 'Animate',
    props: {
        animationType: {
            type: String,
            required: false,
            default: 'fade',
        },
        className: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup() {
        const target = ref()
        const animate = ref(false)

        const observer = new IntersectionObserver(
            ([entry]) => {
                animate.value = entry.isIntersecting
            },
            {
                threshold: 0.1,
            }
        )

        onMounted(() => {
            observer.observe(target.value)
        })

        return {
            animate,
            target,
        }
    },
})
</script>

<style lang="scss" scoped>
.animated-component.fade-enter-from,
.animated-component.zoom-enter-from {
    transition: none;
}

/* Fade animation */
.fade-enter-active,
.fade-leave-active {
    transition: all 1s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: translateY(3rem);
}
</style>
